export default __webpack_public_path__ + "static/media/Icono 12.ec6b56d5.svg";